export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(String(value).replace(/[^0-9.-]+/g, ""));
  if (isNaN(numericValue) || numericValue === 0) {
    return typeof value === "string" && value.trim() ? value : null;
  }

  if (numericValue >= 10000000) {
    return `₹${(numericValue / 10000000).toFixed(2)} Cr`;
  }
  if (numericValue >= 100000) {
    return `₹${(numericValue / 100000).toFixed(2)} Lakh`;
  }
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(numericValue);
};

export const resolveAssetUrl = (path) => {
  if (!path) return "";
  if (
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("blob:") ||
    path.startsWith("data:")
  ) {
    return path;
  }
  const assetBase =
    process.env.REACT_APP_ASSET_URL || process.env.REACT_APP_BASE_URL || "";
  const cleanBase = assetBase.replace(/\/+$/, "");
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${cleanBase}${cleanPath}`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return String(dateStr);
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return String(dateStr);
  }
};

export const stripHtml = (html) => {
  if (!html) return "";
  if (typeof html !== "string") return String(html);
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};
